import { WhiteBorderButton } from '@elements/Button';
import { DarkPopup } from '@elements/Popup';
import { CheckIcon, InfoIcon, XCircleIcon } from '@phosphor-icons/react';

type PalletType = {
  dimensions: {
    length: number;
    width: number;
    height: number;
    unitOfMeasurement: string;
  };
  weight: {
    value: number;
    unit: string;
  };
  quantity: number;
  isStackable: boolean;
};

type PalletBoxPopupProps = {
  value: PalletType[];
  openPopup: () => void;
  totalItems: number;
};

export function PalletQuickView({
  totalItems,
  openPopup,
  value,
}: PalletBoxPopupProps) {
  return (
    <DarkPopup
      trigger={
        <div className="sk:flex! sk:items-center!">
          <span>{totalItems}</span>
          <span>
            <InfoIcon className="sk:mt-1! sk:ml-1!" />
          </span>
        </div>
      }
      hoverable
    >
      <div className="sk:flex! sk:items-center!">
        <b>Pallets</b>
        <WhiteBorderButton
          className="sk:ml-2! sk:p-2!"
          onClick={openPopup}
          size="tiny"
        >
          Edit
        </WhiteBorderButton>
      </div>
      <table className="sk:mt-2!">
        <thead>
          <th className="sk:whitespace-nowrap">Dimensions (in.)</th>
          <th className="sk:whitespace-nowrap sk:px-2!">Weight (lb)</th>
          <th className="sk:whitespace-nowrap">Is Stacked</th>
        </thead>
        <tbody>
          {value?.map?.(pallet => (
            <tr>
              <td>
                {pallet.dimensions.length} x {pallet.dimensions.width} x{' '}
                {pallet.dimensions.height}
              </td>
              <td className="sk:px-2!">{pallet.weight.value}</td>
              <td>
                {pallet.isStackable ? (
                  <CheckIcon size={17} className="sk:mt-1! sk:text-brand" />
                ) : (
                  <XCircleIcon
                    size={17}
                    className="sk:mt-1! sk:text-danger-solid"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </DarkPopup>
  );
}
